export default "__VITE_ASSET__733f598e__"